// extracted by mini-css-extract-plugin
export default {"alert":"alert_alert__-dE+5","danger":"alert_danger__9Gbvn","success":"alert_success__aaF0c","warning":"alert_warning__fvBtO","content":"alert_content__fS7so"};